'use client';

import Image from 'next/image';
import React from 'react';
import laptopMoImage from '../../../assets/laptop-mo.webp';
import { A } from '@osmosis/tailwind-ui/components/Text';
import { Box } from '@osmosis/tailwind-ui/components/Box';
import { H1 } from '@osmosis/tailwind-ui/components/Text';
import { P } from '@osmosis/tailwind-ui/components/Text';
import { FormattedMessage } from 'react-intl';
import backgroundImage from '../../../assets/stacked-waves-haikei.svg';
import EventsBannerBackground from './EventsBannerBackground';
import { bgPrimaryText } from '@osmosis/tailwind-ui/styles/background';

const sharedClasses = 'text-slate-100';

/**
 * Banner for the events page.
 */
const EventsPageBanner = () => {
  return (
    <Box cn={`${bgPrimaryText} p-16 flex justify-center items-center relative`}>
      <Box cn="flex sm:flex-row flex-col gap-16 z-[1]">
        <Box cn="flex flex-col justify-center sm:items-end items-center flex-1">
          <Image
            src={laptopMoImage}
            width={300}
            alt="Mo with a laptop"
            className="object-contain"
            priority={true}
          />
        </Box>

        <Box cn="max-w-xl flex flex-col gap-8 justify-center flex-1">
          <H1 cn={sharedClasses}>
            <FormattedMessage
              id="press.events.banner-text-heading"
              defaultMessage="Learner Events"
            />
          </H1>
          <P cn={sharedClasses}>
            <FormattedMessage
              id="press.events.banner-text-primary"
              defaultMessage="Expand your learning and tune into Osmosis webinars, where health professionals and students share their insight on career tactics, self care, study tips, and more."
            />
          </P>
          <Box>
            <P cn={sharedClasses}>
              <FormattedMessage
                id="press.events.banner-text-webinars"
                defaultMessage="Looking for faculty/educator webinars?"
              />
            </P>
            <P cn={sharedClasses}>
              <FormattedMessage
                id="press.events.banner-text-webinars"
                defaultMessage="Visit <a>Educator Events.</a>"
                values={{
                  a: (chunks) => (
                    <A
                      key="a"
                      cn="text-slate-100 font-bold"
                      href="https://facultyhub.elsevier.com/en/events?type=webinar"
                    >
                      {chunks}
                    </A>
                  ),
                }}
              />
            </P>
          </Box>
        </Box>
      </Box>

      <EventsBannerBackground src={backgroundImage} />
    </Box>
  );
};

export default EventsPageBanner;
